export default "__VITE_ASSET__C54Y4H9J__"